import { trimStart, invoke } from 'lodash';
import { locationChanged } from '../../../actions/one-app';
import { getCurrentLocation } from '../../../selectors/location-history-selectors';
import { getPostIdBySlug } from '../../../selectors/post-selectors';
import detectRoute, { isInPostEditor, isInFeedOrCategory, POST_PAGE } from '../../../services/detect-route';
import { NAV_BUTTON_VALUES } from '../constants';

const PAGE_TITLES = {
  [POST_PAGE]: ({ t }) => t('one-app.post-page-title'),
};
const PAGE_RIGHT_NAV_BUTTONS = {
  [POST_PAGE]: ({ action, getState }) => [
    {
      type: 'menu',
      value: {
        id: NAV_BUTTON_VALUES.POST_MENU,
        postId: getPostIdBySlug(getState(), trimStart(action.payload.pathname, '/')),
      },
    },
  ],
};
const ONE_APP_NAV_ACTIONS = {
  PUSH: 'pushScreen',
  POP: 'popScreen',
};
const DEFAULT_NAV_ACTION = ONE_APP_NAV_ACTIONS.PUSH;

export default function onLocationChange({ action, t }) {
  return (dispatch, getState) => {
    const { payload: nextLocation } = action;
    const currentLocation = getCurrentLocation(getState());
    const shouldNotifyOneApp =
      currentLocation &&
      !(isInFeedOrCategory(currentLocation) && isInFeedOrCategory(nextLocation)) &&
      !(isInPostEditor(currentLocation) || isInPostEditor(nextLocation));

    if (shouldNotifyOneApp) {
      const navAction = ONE_APP_NAV_ACTIONS[nextLocation.action] || DEFAULT_NAV_ACTION;
      const page = detectRoute(nextLocation);
      const title = invoke(PAGE_TITLES, page, { t });
      const rightNavButtons = invoke(PAGE_RIGHT_NAV_BUTTONS, page, { action, getState }) || [];

      dispatch(
        locationChanged(
          navAction === ONE_APP_NAV_ACTIONS.PUSH
            ? { action: navAction, title, rightNavButtons }
            : { action: navAction },
        ),
      );
    }
  };
}
